import { memo, useCallback } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";

import { ChatGeneratedFilesDialogBody } from "./ChatGeneratedFilesDialogBody";
import type { IChatGeneratedFilesDialogProps } from "./types";

// NOTE: NSAI-5312 — "Download generated files" from a chat's menu: the chat's
// generated files, all ticked, downloaded the way the AI Generated Files page
// downloads a selection (one file as itself, several as one ZIP). The dialog
// closes as the download starts; the caller shows its progress in a toast.
const ChatGeneratedFilesDialogComponent = ({
  chatUuid,
  isOpen,
  onOpenChange,
  isDownloading,
  progressLabel,
  onDownload,
}: IChatGeneratedFilesDialogProps): JSX.Element => {
  const handleCancel = useCallback((): void => {
    onOpenChange(false);
  }, [onOpenChange]);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent data-testid="chat-generated-files-dialog">
        <ChatGeneratedFilesDialogBody
          chatUuid={chatUuid}
          isDownloading={isDownloading}
          progressLabel={progressLabel}
          onDownload={onDownload}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
};

export const ChatGeneratedFilesDialog = memo(ChatGeneratedFilesDialogComponent);
